import toast from 'react-hot-toast';
import axiosInstance from '../services/axiosClient';
export const getCandidatesByAssessment = async (assessmentId, params) => {
  const response = await axiosInstance.get(
    `/assessment-candidates/assessment/${assessmentId}`,
    {
      params: {
        page: params.page,
        limit: params.limit,
        search: params.search,
      },
    },
  );
  return response.data;
};

export const exportCandidatesByAssessment = async (assessmentId, params) => {
  try {
    const response = await axiosInstance.get(
      `/assessment-candidates/assessment/${assessmentId}`,
      {
        params: {
          ...params,
          is_export: true,
        },
      },
    );
    return response.data;
  } catch (err) {
    toast.error(err.response.data.message);
    return null;
  }
};
